import { resolve, bindable, BindingMode, IEventAggregator, ILogger } from 'aurelia';

export class TripList {
    @bindable trips;
    @bindable({ mode: BindingMode.twoWay }) filters;
    @bindable tripsLoading = true;

    RESOURCE_BASE_URL = aurelia_options.resourceBaseUrl;
    log = resolve(ILogger).scopeTo('app.Lastminutetrips');
    eventAggregator = resolve(IEventAggregator);
    aurelia_options = aurelia_options;

    constructor() { }

    tripsChanged() {
        this.onlyOneHotel = this.trips.some(trip => trip.hotel !== undefined);
        if (this.onlyOneHotel && this.filters.hotelInfoParams.packagegroupItemId !== "") {
            // wait for the element the element to be added to html
            window.setTimeout(() => {
                let el = document.querySelector(`#packagegroup-service-hotel-${this.filters.hotelInfoParams.packagegroupItemId}`);
                el?.scrollIntoView({ behavior: 'smooth' });
                el?.classList.add('e4-animate-packagegroup-item');
            }, 200)
        }
    }

    attached() {
    }

    toggleGroupDetailsVisibility(packagegroup_id) {
        let isExpanding = !$('#packagegroup-' + packagegroup_id).is(":visible");
        $('#packagegroup-' + packagegroup_id).slideToggle();

        // if detailview is becoming visible then load details view data
        if (isExpanding) {
            this.eventAggregator.publish(`load-packagegroup-details-${packagegroup_id}`, {
                sender: 'trip-list',
                packagegroup_id: packagegroup_id,
                searchParameters: this.filters
            });
        }
        document.querySelectorAll(`.js-offer-group-expand-icon-${packagegroup_id}`).forEach(x => x.classList.toggle('lmt-rotate-90', !isExpanding));
        document.querySelectorAll(`.js-offer-group-expand-icon-${packagegroup_id}`).forEach(x => x.classList.toggle('lmt-rotate--90', isExpanding));
    }

    getDestination(packageGroup) {
        let destination = "";

        if (packageGroup === undefined){
            return "";
        }

        if (packageGroup.country_info[aurelia_options.language] !== undefined) {
            destination = packageGroup.country_info[aurelia_options.language];
        } else {
            destination = packageGroup.country;
        }

        destination = destination + ', ';

        if (packageGroup.resort_info[aurelia_options.language] != undefined) {
            destination = destination + packageGroup.resort_info[aurelia_options.language];
        } else {
            destination = destination + packageGroup.resort;
        }

        return destination;
    }

    sortByDeparture() {
        this.filters.sortOrder = this.filters.sortOrder === 'departure-up' ? 'departure-down' : 'departure-up';
    }

    sortByPrice() {
        this.filters.sortOrder = this.filters.sortOrder === 'price-up' ? 'price-down' : 'price-up';
    }
}
